package org.hs_soft.runmynesto.domain.model.home.options.export.cash_reigster_gloabal_info

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
data class Data(
    @SerialName("cashAssist")
    val cashAssist: CashAssist?
)